import { Enumeration } from '../../../utils/AppEnum';

export class OnPremPortOpeningRequestsTypes extends Enumeration<OnPremPortOpeningRequestsTypes> {

    // eslint-disable-next-line react/static-property-placement
    public displayName: string;

    constructor(name?: string, value?: number, displayName?: string) {
    	super(name, value);
    	this.displayName = displayName;
    }

    public static InternetDMZ = new OnPremPortOpeningRequestsTypes('InternetDMZ', 0, 'L4 <-> Internet/DMZ');

    public static InternalCertConnection = new OnPremPortOpeningRequestsTypes('InternalCertConnection', 1, 'Internal Certified Connection');
}
